export default "__VITE_ASSET__abdeaed7__"